module.exports = __webpack_public_path__ + "static/img/_12.ea920d93.png";